import { useEffect, useState } from 'react';

export function formatOnCall(secs: number): string {
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  return `${m}m ${s.toString().padStart(2, '0')}s`;
}

export function useLiveWait(initialSeconds: number): number {
  const [secs, setSecs] = useState(initialSeconds);
  useEffect(() => {
    setSecs(initialSeconds);
    const id = setInterval(() => setSecs((s) => s + 1), 1000);
    return () => clearInterval(id);
  }, [initialSeconds]);
  return secs;
}

export function useNowMinute(): string {
  const [val, setVal] = useState(() =>
    new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }),
  );
  useEffect(() => {
    const id = setInterval(
      () => setVal(new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })),
      30000,
    );
    return () => clearInterval(id);
  }, []);
  return val;
}

export function formatLongestWait(seconds: number): string {
  if (seconds >= 60) return `${Math.round(seconds / 60)}m`;
  return `${seconds}s`;
}
